import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default reducers => {
  const persisted = persistReducer(
    {
      key: 'root',
      storage,
      whitelist: ['auth', 'user'],
    },
    reducers
  );

  return persisted;
};
